import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.jsx';
import './index.css';
import { ensureUserId } from './utils/ensureUserId';
import { installGlobalErrorHooks } from './lib/installGlobalErrorHooks';

const __UID__ = ensureUserId();
if (typeof window !== 'undefined') {
  window.__UID__ = __UID__;           // handy in DevTools
  console.log('[Greta] user_id =', __UID__);
}

// Install global error handlers
installGlobalErrorHooks();

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>
);

if (import.meta.env.VITE_ENABLE_PWA === "1" && "serviceWorker" in navigator) {
  const host = window.location.hostname;
  // Disable on hosts that don't serve sw.js (e.g. addons.questera.ai)
  const blocked = ["addons.questera.ai"];
  if (!blocked.includes(host)) {
    const base = import.meta.env.BASE_URL || "/";
    const swPath = `${base}sw.js`;
    fetch(swPath, { method: "HEAD" })
      .then(r => {
        if (r.ok) navigator.serviceWorker.register(swPath, { scope: base });
      })
      .catch(() => {});
  }
}

// Also clean up any previously-registered SW on blocked hosts:
if ("serviceWorker" in navigator) {
  const host = window.location.hostname;
  if (["addons.questera.ai"].includes(host)) {
    navigator.serviceWorker.getRegistrations().then(rs => rs.forEach(r => r.unregister()));
  }
}